
export let processAndSetMdfsPromise: Promise<void> | null = null;
let loadGoogleMapPromise: Promise<void> | null = null;
// Global exported variable update gives error in eslint
export const updateProcessAndSetMdfsPromise = (val: Promise<void> | null) => {
  processAndSetMdfsPromise = val;
};

export const updateGoogleMapPromise = (val: Promise<void>) => {
  loadGoogleMapPromise = val;
};

export const canLoadGoogle = async () => {
  await loadGoogleMapPromise;
  return window.google?.maps?.places !== undefined;
};
